import { render, staticRenderFns } from "./RadioSwitch.vue?vue&type=template&id=005a486e&scoped=true&"
import script from "./RadioSwitch.vue?vue&type=script&lang=ts&"
export * from "./RadioSwitch.vue?vue&type=script&lang=ts&"
import style0 from "./RadioSwitch.vue?vue&type=style&index=0&id=005a486e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "005a486e",
  null
  
)

export default component.exports